import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { BackendListModel } from "src/app/models/common/list.model";
import { DomainCode } from "src/app/models/common/model";
import { ApiRoutes } from "src/app/services/apiroutes";
import { DomainCodeApiService } from "src/app/services/domain_code/domain-code-api.service";
import { RequestApiService } from "src/app/services/domain_code/request-api.service";
import { MyOrdersService } from "../../my-orders-table/my-orders-table.service";
import { RequestUpdateModel } from "./request-update.model";
import { BehaviorSubject, Subject } from "rxjs";
import { AuthService } from "src/app/services/auth.service";
import { UserMasterApiService } from "src/app/services/domain_code/user-master-api.service";


@Component({
    selector: 'logzy-request-update-form',
    templateUrl: './request-update-form.component.html',
    styleUrls: ['./request-update-form.component.scss','../../../../pages/one-way-data/request-processing/request-processing.component.scss']
})

export class RequestUpdateFormComponent implements OnInit {
    @Input()
    getReqData = new BehaviorSubject(null);

    requestUpdateObj: RequestUpdateModel;
    leadSourceList: BackendListModel<DomainCode>;
    @Output() close: EventEmitter<any> = new EventEmitter();
    isCustomer: boolean;
    userMaster_url = ApiRoutes.Company;
    canvas: string = "Canvas";
    open1: string = "sidepanel";
    bindName = new BehaviorSubject(null);
    isSidePanelOpen:boolean=false;
    company_url = `${ApiRoutes.Company}company/?name=::search::&is_internal=1`;
    
    constructor(private domainService: DomainCodeApiService,
        public requestService: RequestApiService,
        private snackBar: MatSnackBar,
        private myOrderService: MyOrdersService, private authService: AuthService, private userService: UserMasterApiService,
    ) { }

    ngOnInit() {
        this.isCustomer = this.authService.isCustomer();
        this.requestUpdateObj = new RequestUpdateModel();
        this.getLeadSource();
        this.getReqData.subscribe(item => {
            if (item) {
                this.requestUpdateObj.setRequestPayloadToModel(this.requestService.selectedRequest)
                console.log("requestUpdateObj", this.requestUpdateObj)
            } else {
                this.requestUpdateObj = new RequestUpdateModel();
            }
        })
    }

    getLeadSource() {
        this.domainService.getByGroup('RequestLeadSource').subscribe({
            next: response => {
                this.leadSourceList = response;
            }
        });
    }

    // Update existing requirements
    patchRequest() {
        let reqId = this.requestService.selectedRequest.id;
        this.requestService.patchRequest(reqId, this.requestUpdateObj.getRequestData()).subscribe({
            next: response => {
                this.snackBar.open(`Request details updated`, 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
                this.close.emit();
                return response;
            },
            error: error => {
                return this.catchError(error);
            }
        })
    }

    catchError(error) {
        if (error.status === 400) {
            this.requestUpdateObj.error = { ...error.error }
            return error;
        }
        if (error.status === 403 || error.status === 401) {
            this.snackBar.open(`You are not authorized to update this request`, 'Close', {
                verticalPosition: 'top',
                duration: 3000,
            });
            return error;
        }
        if (error.status === 404) {
            this.snackBar.open(error.statusText, 'Close', {
                verticalPosition: 'top',
                duration: 3000,
            });
            return error;
        }
        if (error.status > 499) {
            this.snackBar.open(`Something went wrong. Please refresh the page.`, 'Close', {
                verticalPosition: 'top',
                duration: 3000,
            });
            return error;
        }
    }

    getSalesDetails(event) {
        if (event.name) {
            this.openEdit(event.name)
        }
        this.requestUpdateObj.sales_person = event;
    }

    openEdit(data) {
        this.open1 = " sidepanel slidepanelOpen ";
        this.canvas = "Canvas setCanvas";
        setTimeout(() => {
            // this.isSidePanelOpen = true;
            this.bindName.next(data);
        }, 500);
    }

    closeEdit() {
        this.open1 = " sidepanel ";
        this.canvas = "Canvas ";
        this.bindName.next(null);
    }

    bindSalesPerson(event) {
        if (event != null) {
            this.getRequestor(event.user_id)
        }
    }
    
    getRequestor(id) {
        this.userService.getUserListByID(id).subscribe({
            next: response => {
                this.requestUpdateObj.sales_person = response;
                this.closeEdit();
                return response;
            }
        })
    }
}